import { useRef, useEffect } from "react";

// import axios from "axios";
import axios from "../axios/axios";
import Cookies from "js-cookie";

import { Box, Button, Checkbox, Container, FormControl, FormLabel, Heading, HStack, Input, Stack, useToast } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { Logo } from "../components/Logo";
import { PasswordField } from "../components/PasswordField";

function LoginPage({ setUser, getDashboardRoute }) {
  const emailInputRef = useRef();
  const passwordInputRef = useRef();
  const navigate = useNavigate();
  const toast = useToast();
  useEffect(() => {
    // Check if the user is already logged in

    const authenticatedUser = Cookies.get("user");
    if (authenticatedUser) {
      const parsedUser = JSON.parse(authenticatedUser);
      navigate(getDashboardRoute(parsedUser.role));
    }
  }, [navigate, getDashboardRoute]);

  function submitHandler(event) {
    event.preventDefault();

    const enteredEmail = emailInputRef.current.value;
    const enteredPassword = passwordInputRef.current.value;

    // Use axios or another method to retrieve the user's salt from the database based on their email
    axios
      .post("/login", { email: enteredEmail, password: enteredPassword })
      .then(response => {
        const authenticatedUser = response.data.user;
        if (authenticatedUser) {
          setUser(authenticatedUser);
          navigate(getDashboardRoute(authenticatedUser.role));
        }
      })
      .catch(error => {
        if (error.response.status !== 200) {
          toast({ title: "Erreur", description: "Identifiants ou mot de passe incorrects. Veuillez réessayer.", status: "error", duration: 9000, isClosable: true });
        }
        if (error.response) {
          toast({ title: "Erreur", description: error.response.data.message, status: "error", duration: 9000, isClosable: true });
        }
      });
  }

  return (
    <Container
      maxW="lg"
      py={{
        base: "12",
        md: "24",
      }}
      px={{
        base: "0",
        sm: "8",
      }}
    >
      <Stack spacing="8">
        <Stack spacing="6">
          <Logo />
          <Stack
            spacing={{
              base: "2",
              md: "3",
            }}
            textAlign="center"
          >
            <Heading
              size={{
                base: "xs",
                md: "sm",
              }}
            >
              Connectez-vous à votre compte
            </Heading>
          </Stack>
        </Stack>
        <Box
          py={{
            base: "0",
            sm: "8",
          }}
          px={{
            base: "4",
            sm: "10",
          }}
          bg={{
            base: "transparent",
            sm: "bg.surface",
          }}
          boxShadow={{
            base: "none",
            sm: "md",
          }}
          borderRadius={{
            base: "none",
            sm: "xl",
          }}
        >
          <Stack spacing="6" as={"form"} onSubmit={submitHandler}>
            <Stack spacing="5">
              <FormControl>
                <FormLabel htmlFor="email">E-mail</FormLabel>
                <Input id="email" type="email" ref={emailInputRef} />
              </FormControl>
              <PasswordField ref={passwordInputRef} />
            </Stack>
            <HStack justify="space-between">
              <Checkbox defaultChecked>Se souvenir</Checkbox>
              <Button variant="text" size="sm">
                Forgot password?
              </Button>
            </HStack>
            <Button type="submit">Se connecter</Button>
          </Stack>
        </Box>
      </Stack>
    </Container>
  );
}

export default LoginPage;
